import React, { FC } from 'react'
import {
  PageTitleWrapper,
  PageHeader,
  SimpleDialog,
  CustomForm,
  ButtonToggle,
  showErrorMessage,
  FormField
} from '../../shared/components/index';
import {
  Grid,
  Container,
  Box,
  Typography,
  Button,
  TextField,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';

import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormFieldType } from '../../shared/components/form-field/service/formFieldInterface';
import {
  I18N,
  LIST_VIEW,
  REGEX,
  ROLES,
  TENANT_ROLES
} from '../../shared/constants/constants';
import * as ROUTES from '../../shared/constants/routes';
import GridViewSharpIcon from '@mui/icons-material/GridViewSharp';
import TableRowsTwoToneIcon from '@mui/icons-material/TableRowsTwoTone';
import SellTwoToneIcon from '@mui/icons-material/SellTwoTone';
import { VIEW_TYPE } from './utils/utils';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import AddAssetModal from './components/AssetModal';
import * as assetTypeService from 'src/modules/Asset-type/services/asset-type_Management.service';
import AssetManagementView from './components/AssetView';
import AssetDetailsTable from './components/AssetDetailsTable';
import ExpenceManagementTable from '../expence/components/ExpenceManagementTable';

interface AssetDetailsProps {
  handlAssetViewBackClick: (row: any) => void;
  handleSellIconClick: (row: any) => void;
  dataSelectedAsset: any;
  inputIsAssetSold: boolean,
  inputBookingAssetData: any[];
  inputAssetExpenceList: any[];
}

const AssetDetails: FC<AssetDetailsProps> = ({
  handlAssetViewBackClick,
  handleSellIconClick,
  dataSelectedAsset,
  inputBookingAssetData,
  inputAssetExpenceList,
  inputIsAssetSold,
}) => {
  const handleSellIconClickAction = () => {
    handleSellIconClick(dataSelectedAsset);
  };
  const { t } = useTranslation(I18N.DEFAULT);
  return (
    <>
      <PageTitleWrapper>
        <PageHeader
        // breadcrumbs={breadcrumbs}
        // heading={breadcrumbsHeading}
        // subHeading={headerSubtitle}
        >
          {/* {viewType == VIEW_TYPE.ASSET_MANAGEMENT && ( */}
          <Button
            size={'small'}
            sx={{ pt: 1, pb: 1 }}
            className="letter-spacing"
            variant={'contained'}
            startIcon={<SellTwoToneIcon fontSize="small" />}

            onClick={handleSellIconClickAction}
          >
            {t('sell')}
          </Button>
          <Button
            size={'small'}
            sx={{ pt: 1, pb: 1 }}
            className="letter-spacing"
            variant={'contained'}
            startIcon={<AddTwoToneIcon fontSize="small" />}
            onClick={handlAssetViewBackClick}
          >
            {t('back')}
          </Button>
          {/* )} */}
          <TextField
            size={'small'}
            id="outlined-search"
            // label={t('search-user')}
            type="search"
          // onChange={(e) => handleFilterUsers(e.target.value)}
          />
          <ToggleButtonGroup
            // value={selectedTab}
            exclusive
            // onChange={handleViewOrientation}
            size={'small'}
          >
            <ToggleButton disableRipple value={LIST_VIEW.CARD_VIEW}>
              <GridViewSharpIcon />
            </ToggleButton>
            <ToggleButton disableRipple value={LIST_VIEW.TABLE_VIEW}>
              <TableRowsTwoToneIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </PageHeader>
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            {inputIsAssetSold ? <ExpenceManagementTable
              inputExpenceData={inputAssetExpenceList}
              inputIsAssetSold={inputIsAssetSold}
              dataSelectedAsset={dataSelectedAsset}
            /> : <AssetDetailsTable
              inputBookingAssetData={inputBookingAssetData}
            />}
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
export default AssetDetails


